module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/fort-battle-10.282e7938.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/fort-battle-10.png
// module id = 2757
// module chunks = 11